module.exports = __webpack_public_path__ + "img/corneal-neovascularisation-0.1fa93eb2.jpg";